import React from "react";
import { GetStaticProps } from "next";

import Article from "@/components/blog/blog-article";
import blogsData from "@/data/blogs.json";
import { ArticleType } from "@/@types/BlogArticle";

type Props = {
  blog: ArticleType;
};

const BlogPage = ({ blog }: Props) => {
  return <Article blogArticle={blog} />;
};

export async function getStaticPaths() {
  // Generate the paths for each news item
  const paths = blogsData.map((blogId) => ({
    params: { blogId: `${blogId.id}` },
  }));

  return {
    paths,
    fallback: true,
  };
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  if (!params || !params.blogId) {
    return {
      notFound: true,
    };
  }

  const blog = blogsData.find(({ id }) => id === params.blogId);

  if (!blog) {
    return {
      notFound: true,
    };
  }

  return {
    props: { blog },
  };
};

export default BlogPage;
